var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createElement, isNullOrUndefined } from '@syncfusion/ej2-base';
import { LineTool, PolygonDrawingTool } from '../drawing/tools';
import { findObjectsUnderMouse } from '../drawing/action';
/**
 * The `LinkAnnotation` module is used to handle link annotation actions of PDF viewer.
 *
 * @hidden
 */
export class LinkAnnotation {
    /**
     * @param {PdfViewer} pdfViewer -It describes about the PdfViewer
     * @param {PdfViewerBase} viewerBase - It describes about the viewerbase
     * @private
     */
    constructor(pdfViewer, viewerBase) {
        this.pdfViewer = pdfViewer;
        this.pdfViewerBase = viewerBase;
    }
    /**
     * @param {any} data - It describes about the data
     * @param {number} pageIndex - It describes about the number
     * @private
     * @returns {void}
     */
    renderHyperlinkContent(data, pageIndex) {
        if (this.pdfViewer.enableHyperlink) {
            const hyperlinks = data.hyperlinks;
            const hyperlinksBounds = data.hyperlinkBounds;
            this.linkAnnotation = data.linkAnnotation;
            this.linkPage = data.linkPage;
            this.annotationY = data.annotationLocation;
            if (hyperlinks && hyperlinks.length > 0 && hyperlinksBounds.length > 0) {
                this.renderWebLink(hyperlinks, hyperlinksBounds, pageIndex);
            }
            if (this.linkAnnotation && this.linkAnnotation.length > 0 && this.linkPage.length > 0) {
                this.renderDocumentLink(this.linkAnnotation, this.linkPage, this.annotationY, pageIndex);
            }
        }
    }
    /**
     * @param {HTMLElement} eventTarget - It describes about the event target
     * @param {MouseEvent} evt - It describes about the event
     * @param {any} element - It describes about the element
     * @private
     * @returns {void}
     */
    disableHyperlinkNavigationUnderObjects(eventTarget, evt, element) {
        const objects = findObjectsUnderMouse(element, element.pdfViewer, evt);
        if (objects.length > 0) {
            if (evt.target.classList.contains('e-pv-hyperlink')) {
                eventTarget.style.cursor = 'move';
                eventTarget.style.pointerEvents = 'none';
                eventTarget.title = '';
            }
        }
        else {
            const hyperlinkObjects = document.getElementsByClassName('e-pv-hyperlink');
            if (hyperlinkObjects && hyperlinkObjects.length > 0) {
                for (let i = 0; i < hyperlinkObjects.length; i++) {
                    if (hyperlinkObjects[parseInt(i.toString(), 10)].style.pointerEvents === 'none') {
                        hyperlinkObjects[parseInt(i.toString(), 10)].style.pointerEvents = 'all';
                    }
                    if (!hyperlinkObjects[parseInt(i.toString(), 10)].title) {
                        hyperlinkObjects[parseInt(i.toString(), 10)].title = hyperlinkObjects[parseInt(i.toString(), 10)].href;
                    }
                }
            }
        }
    }
    renderWebLink(hyperlinks, hyperlinksBounds, pageIndex) {
        // eslint-disable-next-line
        const proxy = this;
        let isHyperlinkClicked = false;
        for (let i = 0; i < hyperlinks.length; i++) {
            let aTag = createElement('a', { id: 'weblinkdiv_' + i + '_' + pageIndex });
            const rect = hyperlinksBounds[parseInt(i.toString(), 10)];
            aTag = this.setHyperlinkProperties(aTag, rect, pageIndex);
            aTag.title = hyperlinks[parseInt(i.toString(), 10)];
            if (hyperlinks[parseInt(i.toString(), 10)] && hyperlinks[parseInt(i.toString(), 10)].split('http').length === 1) {
                const hyperlinkText = 'http://' + hyperlinks[parseInt(i.toString(), 10)];
                aTag.setAttribute('href', hyperlinkText);
            }
            else {
                aTag.setAttribute('href', hyperlinks[parseInt(i.toString(), 10)]);
            }
            if (this.pdfViewer.hyperlinkOpenState === 'CurrentTab') {
                aTag.target = '_self';
                aTag.onclick = (e) => __awaiter(this, void 0, void 0, function* () {
                    if (!isHyperlinkClicked) {
                        e.preventDefault();
                        if (proxy.pdfViewerBase.tool instanceof LineTool || proxy.pdfViewerBase.tool instanceof PolygonDrawingTool) {
                            return false;
                        }
                        else {
                            const isCancel = yield proxy.pdfViewer.fireHyperlinkClick(hyperlinks[parseInt(i.toString(), 10)], aTag);
                            if (isCancel && this.pdfViewer.selectedItems.annotations.length === 0 &&
                                this.pdfViewer.selectedItems.formFields.length === 0) {
                                isHyperlinkClicked = true;
                                aTag.click();
                            }
                            return isCancel;
                        }
                    }
                    else {
                        isHyperlinkClicked = false;
                        return true;
                    }
                });
                aTag.onmouseover = () => {
                    proxy.triggerHyperlinkEvent(aTag);
                };
            }
            else if (this.pdfViewer.hyperlinkOpenState === 'NewTab') {
                aTag.target = '_blank';
                aTag.onclick = (e) => __awaiter(this, void 0, void 0, function* () {
                    if (!isHyperlinkClicked) {
                        e.preventDefault();
                        if (proxy.pdfViewerBase.tool instanceof LineTool || proxy.pdfViewerBase.tool instanceof PolygonDrawingTool) {
                            return false;
                        }
                        else {
                            const isCancel = yield proxy.pdfViewer.fireHyperlinkClick(hyperlinks[parseInt(i.toString(), 10)], aTag);
                            if (isCancel && this.pdfViewer.selectedItems.annotations.length === 0 &&
                                this.pdfViewer.selectedItems.formFields.length === 0) {
                                isHyperlinkClicked = true;
                                aTag.click();
                            }
                            return isCancel;
                        }
                    }
                    else {
                        isHyperlinkClicked = false;
                        return true;
                    }
                });
                aTag.onmouseover = () => {
                    proxy.triggerHyperlinkEvent(aTag);
                };
            }
            else if (this.pdfViewer.hyperlinkOpenState === 'NewWindow') {
                aTag.onclick = (e) => __awaiter(this, void 0, void 0, function* () {
                    e.preventDefault();
                    if (proxy.pdfViewerBase.tool instanceof LineTool || proxy.pdfViewerBase.tool instanceof PolygonDrawingTool) {
                        return false;
                    }
                    else {
                        const isCancel = yield proxy.pdfViewer.fireHyperlinkClick(hyperlinks[parseInt(i.toString(), 10)], aTag);
                        if (isCancel && this.pdfViewer.selectedItems.annotations.length === 0 &&
                            this.pdfViewer.selectedItems.formFields.length === 0) {
                            window.open(aTag.href, '_blank', 'scrollbars=yes,resizable=yes');
                        }
                        return false;
                    }
                });
                aTag.onmouseover = () => {
                    proxy.triggerHyperlinkEvent(aTag);
                };
            }
            const pageDiv = document.getElementById(this.pdfViewer.element.id + '_pageDiv_' + pageIndex);
            if (!isNullOrUndefined(pageDiv)) {
                pageDiv.appendChild(aTag);
            }
        }
    }
    triggerHyperlinkEvent(aTag) {
        if (this.pdfViewerBase.tool instanceof LineTool || this.pdfViewerBase.tool instanceof PolygonDrawingTool) {
            return false;
        }
        else {
            this.pdfViewer.fireHyperlinkHover(aTag);
            return true;
        }
    }
    renderDocumentLink(linkAnnotation, linkPage, annotationY, pageIndex) {
        // eslint-disable-next-line
        const proxy = this;
        for (let i = 0; i < linkAnnotation.length; i++) {
            let aTag = createElement('a', { id: 'linkdiv_' + i + '_' + pageIndex });
            const rect = linkAnnotation[parseInt(i.toString(), 10)];
            aTag = this.setHyperlinkProperties(aTag, rect, pageIndex);
            aTag.setAttribute('href', 'javascript:void(0)');
            const linkPageNum = linkPage[parseInt(i.toString(), 10)];
            if (!isNullOrUndefined(linkPageNum) && linkPageNum >= 0) {
                const destPageHeight = (this.pdfViewerBase.pageSize[parseInt(pageIndex.toString(), 10)].height);
                let destLocation;
                let scrollValue;
                const pageSize = this.pdfViewerBase.pageSize[parseInt(linkPageNum.toString(), 10)];
                if (pageSize) {
                    if (!isNullOrUndefined(annotationY) && annotationY.length !== 0) {
                        destLocation = (annotationY[parseInt(i.toString(), 10)]);
                        scrollValue = pageSize.top * this.pdfViewerBase.getZoomFactor() +
                            ((destPageHeight - destLocation) * this.pdfViewerBase.getZoomFactor());
                    }
                    else {
                        scrollValue = pageSize.top * this.pdfViewerBase.getZoomFactor();
                    }
                }
                if (scrollValue !== undefined) {
                    aTag.name = scrollValue.toString();
                    aTag.setAttribute('aria-label', scrollValue.toString());
                }
                else if ((isNullOrUndefined(pageSize) && linkPageNum > this.pdfViewerBase.pageSize.length)) {
                    aTag.dataset.annotationY = JSON.stringify(annotationY);
                    aTag.dataset.pageIndex = JSON.stringify(linkPageNum);
                    aTag.dataset.index = JSON.stringify(i);
                }
                aTag.onclick = () => {
                    if (proxy.pdfViewerBase.tool instanceof LineTool || proxy.pdfViewerBase.tool instanceof PolygonDrawingTool) {
                        return false;
                    }
                    else {
                        if (!aTag.name) {
                            if (aTag.dataset.pageIndex) {
                                const pageSize = proxy.pdfViewerBase.pageSize[JSON.parse(aTag.dataset.pageIndex)];
                                const annotationVal = JSON.parse(aTag.dataset.annotationY);
                                const index = JSON.parse(aTag.dataset.index);
                                const zoomFactor = this.pdfViewerBase.getZoomFactor();
                                if (annotationVal && annotationVal.length > 0) {
                                    destLocation = (annotationY[parseInt(index.toString(), 10)]);
                                    scrollValue = pageSize.top * zoomFactor +
                                        ((destPageHeight - destLocation) * zoomFactor);
                                }
                                else {
                                    scrollValue = pageSize.top * zoomFactor;
                                }
                            }
                            aTag.name = scrollValue.toString();
                            aTag.setAttribute('aria-label', scrollValue.toString());
                        }
                        proxy.pdfViewerBase.viewerContainer.scrollTop = parseInt(aTag.name, 10);
                        return false;
                    }
                };
                const pageDiv = document.getElementById(this.pdfViewer.element.id + '_pageDiv_' + pageIndex);
                if (!isNullOrUndefined(pageDiv)) {
                    pageDiv.appendChild(aTag);
                }
            }
        }
    }
    setHyperlinkProperties(aTag, rect, pageIndex) {
        aTag.className = 'e-pv-hyperlink';
        aTag.style.background = 'transparent';
        aTag.style.position = 'absolute';
        aTag.style.left = (rect.Left * this.pdfViewerBase.getZoomFactor()) + 'px';
        aTag.style.top = (rect.Top * this.pdfViewerBase.getZoomFactor()) + 'px';
        aTag.style.width = (rect.Width * this.pdfViewerBase.getZoomFactor()) + 'px';
        if (rect.Height < 0) {
            aTag.style.height = (-rect.Height * this.pdfViewerBase.getZoomFactor()) + 'px';
            aTag.style.top = ((rect.Top + rect.Height) * this.pdfViewerBase.getZoomFactor()) + 'px';
        }
        else {
            aTag.style.height = ((rect.Height < 0 ? -rect.Height : rect.Height) * this.pdfViewerBase.getZoomFactor()) + 'px';
        }
        aTag.style.color = 'transparent';
        this.pdfViewerBase.applyElementStyles(aTag, pageIndex);
        return aTag;
    }
    /**
     * @param {number} pageNumber - It describes about the page number
     * @param {boolean} isAdd - It describes about the isAdd
     * @private
     * @returns {void}
     */
    modifyZindexForTextSelection(pageNumber, isAdd) {
        if (this.pdfViewerBase.pageCount > 0) {
            const pageDiv = this.pdfViewerBase.getElement('_pageDiv_' + pageNumber);
            if (pageDiv) {
                const pageChildNodes = pageDiv.childNodes;
                for (let i = 0; i < pageChildNodes.length; i++) {
                    const childElement = pageChildNodes[parseInt(i.toString(), 10)];
                    if (childElement.tagName === 'A') {
                        if (isAdd) {
                            childElement.classList.add('e-pv-onselection');
                        }
                        else {
                            childElement.classList.remove('e-pv-onselection');
                        }
                    }
                }
            }
        }
    }
    /**
     * @param {HTMLElement} element - It describes about the element
     * @param {boolean} isAdd - It describes about the isAdd
     * @private
     * @returns {void}
     */
    modifyZindexForHyperlink(element, isAdd) {
        if (isAdd) {
            element.classList.add('e-pv-onselection');
        }
        else {
            element.classList.remove('e-pv-onselection');
        }
    }
    /**
     * @private
     * @returns {void}
     */
    destroy() {
        for (let i = 0; i < this.pdfViewerBase.pageCount - 1; i++) {
            const pageDiv = document.getElementById(this.pdfViewer.element.id + '_pageDiv_' + i);
            if (pageDiv) {
                const aElement = pageDiv.getElementsByTagName('a');
                if (aElement.length !== 0) {
                    for (let index = aElement.length - 1; index >= 0; index--) {
                        aElement[parseInt(index.toString(), 10)].parentNode.removeChild(aElement[parseInt(index.toString(), 10)]);
                    }
                }
            }
        }
        this.linkAnnotation = null;
        this.linkPage = null;
        this.annotationY = null;
    }
    /**
     * @private
     * @returns {string} - string
     */
    getModuleName() {
        return 'LinkAnnotation';
    }
}
